//import http from "../http-common";
import api from "../http-common";

class AlumnosDataService {
  getAll() { 
    return api.get("/alumnos");
  }

  get(id) {
    return api.get(`/alumnos/${id}`);
  }

  create(data) {
    return api.post("/alumnos/create/", data);
  }

  update(id, data) {
    return api.put(`/alumnos/update/${id}/`, data);
  }

  delete(id) {
    return api.delete(`/alumnos/delete/${id}`);
  }

  getoalumnos(){
   return api.get('/alumnos/movalumno'); 
  }

  getOaloumno(id, ciclo){
    return api.get(`/alumnos/movalumno/${id}`, {
      params: {
        ciclo: ciclo
      }
    });
  }

  getOalumnoEgresado(id, ciclo){
    return api.get(`/alumnos/movalumno/egresados/${id}`, {
      params: {
        ciclo: ciclo
      }
    });
  }

}

export default new AlumnosDataService();